<template>
  <v-btn
    data-testid="vc-dashed-button"
    elevation="0"
    class="vc-dashed-button d-flex align-center pa-3"
    height="24px"
    @click="onClick"
    :disabled="disabled">
    <template v-if="icon">
      <v-icon class="me-1" x-small>{{icon}}</v-icon>
    </template>
    <span class="label-span font-weight-regular">
      {{label}}
    </span>
  </v-btn>
</template>

<script>
export default {
  name: "VcDashedButton",
  methods:{
    onClick(e){
      this.$emit('click', e)
    }
  },
  props:{
    label:{
      type:String,
      required: false
    },
    disabled:{
      type:Boolean,
      default: false
    },
    icon: {
      type: String,
      required: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
.vc-dashed-button{
  min-width: 77px;
  border: 1px dashed rgba(221,221,221);
  transition: background-color .1s ease;
  font-size: 13px;
  border-radius: 60px;
  .label-span{
    font-family: var(--primary-font-family);
    font-size: 13px;
    font-style: normal;
    line-height: 16px;
    letter-spacing: 0em;
    color: $black-color-2;
  }
  &::v-deep{
    &.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):not(:active){
      color: $color_dark_text;
      background-color: transparent;
    }
    // Hover
    &.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover{
      background-color: rgba(0,0,0,0.07)
    }
    // Active
    &.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):active{
      background-color: rgba(0, 0, 0, 0.2);
    }
    // Focus
    &.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):not(:active):focus{
      box-shadow: 0px 0px 0px 3px rgba(var(--brand-color-secondary-rgb), 0.36) !important;
    }
    &.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):active:focus{
      box-shadow: none !important;
    }
    &.v-btn:not(.v-btn--text):not(.v-btn--outlined):focus:before{
      opacity: 0;
    }
    // Disabled
    &.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
      color: $grey-color-17 !important;
      background-color: rgba(0,0,0,0.07) !important;
    }
    &.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) span.label-span{
      color: $grey-color-17
    }
  }
}
</style>
